var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVpnKey24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9989 19.0013L22.9989 19.0018L22.9992 15.0018L24.9992 15.002L24.9997 9.00197L14.3197 9.00109C13.1699 6.581 10.72 5.0008 8 5.00057C4.14 5.00026 0.999743 8.14 0.999426 12C0.99911 15.86 4.13885 19.0003 7.99885 19.0006C10.7189 19.0008 13.179 17.421 14.3192 15.0011L16.9992 15.0013L16.9989 19.0013ZM20.999 17.0016L18.999 17.0015L18.9993 13.0015L12.9393 13.001L12.7093 13.671C12.0091 15.6609 10.109 17.0007 7.99902 17.0006C5.23902 17.0003 2.9992 14.7602 2.99943 12.0002C2.99965 9.24016 5.23984 7.00035 7.99984 7.00057C10.1098 7.00075 12.0097 8.3409 12.7096 10.331L12.9395 11.001L22.9995 11.0018L22.9993 13.0018L20.9993 13.0016L20.999 17.0016ZM7.99918 15.0006C6.34918 15.0004 4.99929 13.6503 4.99943 12.0003C4.99956 10.3503 6.34967 9.00044 7.99967 9.00057C9.64967 9.00071 10.9996 10.3508 10.9994 12.0008C10.9993 13.6508 9.64918 15.0007 7.99918 15.0006ZM6.99943 12.0005C6.99947 11.4505 7.44951 11.0005 7.99951 11.0006C8.54951 11.0006 8.99947 11.4507 8.99943 12.0007C8.99938 12.5507 8.54934 13.0006 7.99934 13.0006C7.44934 13.0005 6.99938 12.5505 6.99943 12.0005Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnKey24Px);
export default __webpack_public_path__ + "static/media/vpn_key_24px.3e9f1c8699eed52e7b2b21b4adf4fea8.svg";
export { ForwardRef as ReactComponent };